import { get } from 'lodash';

const root = state =>
  get(state, 'SimpleAverageReportState.simpleAverageReport');

export const getLoading = state => get(root(state), 'loading');
export const getCycleMenus = state => get(root(state), 'cycleMenus');



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/state/simpleaverage/selectors.js